import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { detectLaunchContext, type LaunchContext } from "@common-ui/utilities/launchContext";

// LSP-21256: record whether the dashboard is running in a browser tab or as a Home Screen web app.
// Set as Datadog global context (logs AND RUM) so every later dashboard event — recording starts,
// upload diagnostics, errors — carries @launchContext.* without depending on console forwarding.
// Field meanings: docs/observability/launch-context-telemetry.md.

interface LaunchContextSinks {
	logs: Pick<typeof datadogLogs, "setGlobalContextProperty"> & { logger: Pick<typeof datadogLogs.logger, "info"> };
	rum: Pick<typeof datadogRum, "setGlobalContextProperty">;
}

export function registerDashboardLaunchContext(
	targetWindow: Window = window,
	sinks: LaunchContextSinks = { logs: datadogLogs, rum: datadogRum }
): LaunchContext | undefined {
	try {
		const launchContext = detectLaunchContext(targetWindow);
		sinks.logs.setGlobalContextProperty("launchContext", launchContext);
		sinks.rum.setGlobalContextProperty("launchContext", launchContext);
		sinks.logs.logger.info("launchContext.dashboard", { launchContext });
		return launchContext;
	} catch (error) {
		// Telemetry must never break app startup.
		try {
			console.warn("launchContext.dashboard: could not record the launch context", error);
		} catch {
			// console itself unavailable — nothing left to report to.
		}
		return undefined;
	}
}
